// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"28e53a8c","374":"df43a3ed","981":"9b4d7435"}[chunkId] + ".chunk.js";
};